<modal-panel title="Filter KT Trips" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>Trip Reference</mat-label>
        <input matInput formControlName="TripReference" placeholder="e.g. ABCDEF"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Client Name</mat-label>
        <input matInput formControlName="ClientName" placeholder="e.g. Smith"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Agent Name</mat-label>
        <input matInput formControlName="AgentName" placeholder="e.g. Jones"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Vendor Name</mat-label>
        <input matInput formControlName="VendorName" placeholder="e.g. Marriott"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Cancelled</mat-label>
        <mat-select formControlName="IsCancelled">
          <mat-option [value]="null">All</mat-option>
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Booked Date From</mat-label>
        <input matInput readonly [matDatepicker]="bookedFrom" formControlName="BookedDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #bookedFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="bookedFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Booked Date To</mat-label>
        <input matInput readonly [matDatepicker]="bookedTo" formControlName="BookedDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #bookedTo/>
        <mat-datepicker-toggle matIconSuffix [for]="bookedTo"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Trip Start Date From</mat-label>
        <input matInput readonly [matDatepicker]="tripStartFrom" formControlName="TripStartDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #tripStartFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="tripStartFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Trip Start Date To</mat-label>
        <input matInput readonly [matDatepicker]="tripStartTo" formControlName="TripStartDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #tripStartTo/>
        <mat-datepicker-toggle matIconSuffix [for]="tripStartTo"/>
      </mat-form-field>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
